import { Role } from "../api/models/User";

export const getClientInfoFromRoles = (roles: Role[]) => {
  const isAdmin = roles.some(
    (role) => role.isCurrentRole && role.name === "ROLE_ADMIN",
  );
  const hasClientRole = roles.some(
    (role) => role.isCurrentRole && role.name.includes("ROLE_CLIENT_"),
  );

  const clientName = hasClientRole
    ? roles.find((d) => d.isCurrentRole)?.client?.name
    : null;

  return { isAdmin, hasClientRole, clientName };
};
